export default {
  name: 'PasswordVisibilityButton',

  props: {
    field: {
      type: HTMLInputElement,
      required: true
    }
  },

  data() {
    return {
      isOver: false
    };
  },

  methods: {
    onOver() {
      this.isOver = true;
      this.field.setAttribute('type', 'text');
    },
    onOut() {
      this.isOver = false;
      this.field.setAttribute('type', 'password');
    }
  }
};
